export default {
    controller: 'editReservationDetailsController',
    template: require('../views/editReservationDetails.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/basket/components/editReservationDetails.component.js